import { render, staticRenderFns } from "./ZaitonTransferContractDesignArabic.vue?vue&type=template&id=7227e874&scoped=true&"
import script from "./ZaitonTransferContractDesignArabic.vue?vue&type=script&lang=js&"
export * from "./ZaitonTransferContractDesignArabic.vue?vue&type=script&lang=js&"
import style0 from "./ZaitonTransferContractDesignArabic.vue?vue&type=style&index=0&id=7227e874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227e874",
  null
  
)

export default component.exports